angular.module('MonstaFTP').filter('spaces_to_nbsp', function () {
    return function (input) {
        return input.replace(/ /g, String.fromCharCode(160));
    };
});
